import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '../Elements';
import { textToDate, textToTime } from 'utils/common';

import classes from './DateTime.module.scss';

const DateTime = ({ date, time = false }) => {
  if (
    !(
      date &&
      date !== '-' &&
      date !== 'NA' &&
      date !== '1970-01-01T00:00:00.000Z'
    )
  ) {
    return 'NA';
  }

  const newDate = new Date(date);
  const viewDate = textToDate(newDate);

  return (
    <Text className={classes.dateTime}>
      {viewDate}
      {time ? (
        <Text size={0} className={classes.dateTime_time}>
          {textToTime(newDate)}
        </Text>
      ) : null}
    </Text>
  );
};

DateTime.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  time: PropTypes.bool
};

export default DateTime;
